<template>
  <section class="section section_bg custom_page_v2 section_black" >
    <loading-block v-if="isload==false" :loading="!isload"/>
    <card class="loading_div" v-if="isload==false">
      <h2>{{ load_message }}</h2>
    </card>
    <div v-if="isload==true">
      <div class="container-fluid mobile_div">
        <div class="section_header mobile_div back_div_element"   >
          <router-link tag="a" class="btn" :to="{name: 'portfolio',query:{tab_active:'settings'}}"  ><i class="fa fa-backward"></i> Назад</router-link>

        </div>


        <div class="">
         <div class="section_header mobile_div nocenter">
           <h2 class="pt-4 text-center">{{ service.name}}</h2>
           <div class=" ml-5 mb-5">

             <div class="col-12">
               <div class="alert alert-danger" v-if="iserror==true">
                 <p>{{ error_message }}</p>
               </div>
               <form @submit.prevent="onSubmit($event)">

                 <div class="col-12 mt-4 mb-4" v-if="service.form_setting.length>0">
                   <p >Включить фильтрацию </p>
                   <select class="form-select" v-model="user_config.isfilter">
                     <option value="0">выключена</option>
                     <option value="1">включена</option>
                   </select>

                 </div>
                 <div v-if="service.form_setting.length>0" class=" mt-4 mb-4" v-for="(question,question_index) in service.form_setting">
                   <div class="col-12 ">
                     <p >{{ question.text_before }} </p>
                   </div>
                   <div class="col-12">
                     <select class="form-control" multiple="true" v-model="user_config.filter_data[question.name]">
                       <option v-for="(option,option_key) in question.options" :value="option_key">{{ option}}</option>
                     </select>
                   </div>

                 </div>

                 <div class="mt-4 mb-4" v-if="is_have_datetime">

                   <div class="row mb-4">
                     <div class="col-12">
                       <p>Длительность услуги в минутах <input type="number" v-model="user_config.filter_data['rasp']['duration']"/></p>
                     </div>
                     <div class="col-md-6 col-12 card section_no_background ">
                       <input type="checkbox" value="1" v-model="user_config.filter_data['rasp']['status_day1']"><b class="shop_setting_title">Понедельник</b>

                       <p>Время работы с <input type="time" v-model="user_config.filter_data['rasp']['day1']['start']"/></p>
                       <p>Время работы по <input type="time" v-model="user_config.filter_data['rasp']['day1']['end']"/></p>
                       <p>&nbsp;</p>
                     </div>

                     <div class="col-md-6 col-12 card  section_no_background">
                       <input type="checkbox" value="1" v-model="user_config.filter_data['rasp']['status_day2']"><b class="shop_setting_title">Вторник</b>

                       <p>Время работы с <input type="time" v-model="user_config.filter_data['rasp']['day2']['start']"/></p>
                       <p>Время работы по <input type="time" v-model="user_config.filter_data['rasp']['day2']['end']"/></p>
                       <p>&nbsp;</p>
                     </div>
                     <div class="col-md-6 col-12 card section_no_background">
                       <input type="checkbox" value="1" v-model="user_config.filter_data['rasp']['status_day3']"><b class="shop_setting_title">Среда</b>

                       <p>Время работы с <input type="time" v-model="user_config.filter_data['rasp']['day3']['start']"/></p>
                       <p>Время работы по <input type="time" v-model="user_config.filter_data['rasp']['day3']['end']"/></p>
                       <p>&nbsp;</p>
                     </div>
                     <div class="col-md-6 col-12 card section_no_background ">

                       <input type="checkbox" value="1" v-model="user_config.filter_data['rasp']['status_day4']"><b class="shop_setting_title">Четверг</b>

                       <p>Время работы с <input type="time" v-model="user_config.filter_data['rasp']['day4']['start']"/></p>
                       <p>Время работы по <input type="time" v-model="user_config.filter_data['rasp']['day4']['end']"/></p>
                       <p>&nbsp;</p>
                     </div>
                     <div class="col-md-6 col-12 card section_no_background ">
                       <input type="checkbox" value="1" v-model="user_config.filter_data['rasp']['status_day5']"><b class="shop_setting_title">Пятница</b>
                       <p>Время работы с <input type="time" v-model="user_config.filter_data['rasp']['day5']['start']"/></p>
                       <p>Время работы по <input type="time" v-model="user_config.filter_data['rasp']['day5']['end']"/></p>
                       <p>&nbsp;</p>
                     </div>
                     <div class="col-md-6 col-12 card section_no_background">
                       <input type="checkbox" value="1" v-model="user_config.filter_data['rasp']['status_day6']"><b class="shop_setting_title">Суббота</b>

                       <p>Время работы с <input type="time" v-model="user_config.filter_data['rasp']['day6']['start']"/></p>
                       <p>Время работы по <input type="time" v-model="user_config.filter_data['rasp']['day6']['end']"/></p>
                       <p>&nbsp;</p>
                     </div>
                     <div class="col-md-6 col-12 card section_no_background ">

                       <input type="checkbox" value="1" v-model="user_config.filter_data['rasp']['status_day7']"><b class="shop_setting_title">Воскресенье</b>

                       <p>Время работы с <input type="time" v-model="user_config.filter_data['rasp']['day7']['start']"/></p>
                       <p>Время работы по <input type="time" v-model="user_config.filter_data['rasp']['day7']['end']"/></p>
                       <p>&nbsp;</p>
                     </div>
                   </div>
                 </div>
                 <!--                <div class="form-group">-->
                 <!--                  <label for="exampleInputEmail1">Реквизиты </label>-->
                 <!--                  <textarea class="form-control text_rekv" required id="exampleInputEmail1" v-model="account"-->
                 <!--                            placeholder="Введите реквизиты"></textarea>-->




                 <!--                </div>-->

                 <div class="alert alert-danger" v-if="iserror==true">
                   <p>{{ error_message }}</p>
                 </div>
                 <div class="form-group mt-4 mb-4">
                   <button type="submit" class="mt-3 btn  ">Сохранить
                   </button>
                 </div>
               </form>
             </div>

           </div>
         </div>
        </div>
      </div>

    </div>
  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "SetupService",

  data() {
    var app = this;


    return {
      "iserror": false,
      "isload":false,
      "error_message": null,
      "service":{},
      "user_config":{},
      'is_have_datetime':false,

      "load_message":"Идет загрузка..",
      "isload_avatar": false,

    }
  },
  mounted() {


    var app = this;
    app.isload = false;
    let id = app.$route.params.id;
    app.loadService(id,function(data){
      app.service=data.service;
      app.is_have_datetime=data.is_have_datetime;
      app.user_config=data.user_config;
      //app.user_config.filter_data=app.user_config.filter;
      if(app.user_config.filter_data==null){
        app.user_config.filter_data={};
      }



      app.disableLoad();
    })




  },

  methods: {
    loadService(id,callback){
    Api.LoadFreelanceService(id,function(data){
      callback(data);
    })
    },
    setLoad(message="Идет загрузка..."){
      var app=this;
      app.isload=false;
      app.load_message=message;

    },
    disableLoad(){
      var app=this;
      app.load_message="Идет загрузка";
      app.isload=true;
    },
    onSubmit(event) {

      event.preventDefault();
      var app = this;
      app.isload=false;
      app.setLoad("Идет сохранение...");
      var form={
        'user_config':app.user_config,
      };
      var new_notifys={"site":{},'telegram':{}};

      Api.FreelanceSetService(app.service.last_id,form,function(data){
        app.disableLoad();
      },function(err){
        app.iserror = true;
        app.error_message = err;
        app.disableLoad();
      })







    },

  },
  components: {vueDropzone: vue2Dropzone,LoadingBlock}
};
</script>